import React from 'react';
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, Cell } from 'recharts';

function CustomPieChart({ data }) {
    return (
        <div style={{ width: "100%", height: "200px", minHeight: "225px" }}>
            <ResponsiveContainer width="100%" height={"100%"}>
                <PieChart margin={{ right: 30, left:30 }}>
                    <Pie
                        dataKey="value"
                        isAnimationActive={false}
                        data={data}
                        cx="50%"
                        cy="50%"
                        outerRadius="70%" // Adjust radius dynamically
                        fill="#8884d8"
                        label={(entry) => `${entry.value.toFixed(1)}`}
                    >
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.color}
                                strokeWidth={1}
                                stroke={entry.color}
                            />
                        ))}
                    </Pie>
                    <Tooltip formatter={(value) => value.toFixed(1)} />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default CustomPieChart;
